/** 页面及 navbar 配置
 * @param backgroundColor     页面背景色
 * @param headColor           页面背景渐变色
 * @param img                 页面背景图片
 * @param paddingTop          上内边距
 * @param paddingBottom       下内边距
 *
 * @param color           navbar 背景色
 *          - bgColor       - 背景色
 *          - scrollBgColor - 滚动时的背景色
 * @param showTitle   是否显示标题，0-不显示、1-显示
 * @param title       页面标题
 * @param fontColor       navbar 图标、文字颜色
 *          - bgColor       - 颜色色
 *          - scrollBgColor - 滚动时的颜色
 */
export type TopNavbarProps = {
  backgroundColor?: string;
  headColor?: string;
  img?: string;
  // paddingTop?: number | string;
  // paddingBottom?: number | string;

  color?: {
    bgColor?: string;
    scrollBgColor?: string;
  };
  showTitle?: 0 | 1;
  title?: string;
  fontColor?: {
    color?: string;
    scrollColor?: string;
  };
}

export enum BgImageType {
  '背景渐变色',
  '背景图片',
}
